export const LABOR_COST_CONCEPT_CALCULATION_TYPES = {
  ADD_TO_TOTAL: 'add_to_total',
  SUBTRACT_FROM_TOTAL: 'subtract_from_total',
} as const

export interface FinancialWorkspaceSettingsFormValues {
  conceptIdsToAdd: string[]
  conceptIdsToSubtract: string[]
}

export const DEFAULT_CONCEPT_NAMES = {
  EXPENSES: 'expenses',
  COMPANY_COST: 'company_cost',
}
